<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p class="yellow">Hugo Verdonck</p>
                        <p class="green">Céréalier à Coulanges-Sur-Yonne (Yonne)</p>
                    </figcaption>
                </figure>
            </section>

            <section>
                <svg class="quote yellow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>Une meilleure valorisation de mes terres à faibles potentiels pour pérenniser l'exploitation</h2>
                <h1>
                    <span>Agir aux côtés</span>
                    <span>d'hugo et de tous</span>
                    <span>les <em>agriculteurs</em></span>
                </h1>

                <h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>

            </section>
        </article>
        <article class="xs-reverse">
            <section class="text-right">


                <p class="number yellow">
                    88<sup>%</sup>
                </p>

                <p class="green uppercase semiBold">
                    Des agriculteurs qui ont un Smartphone utilisent des applications dans le cadre de leur activité
                </p>

                <p class="number yellow">
                    70<sup>%</sup>
                </p>

                <p class="green uppercase semiBold">
                    Des agriculteurs affirment que les nouvelles technologies leur font gagner du temps
                </p>


                <img class="icono w96" :src="require('../assets/fleuro.svg')">
                <p class="label green">
                    Financement
                </p>

                <p class="green uppercase semiBold">
                    Soutenir la 1<sup>re</sup> plateforme de financement participatif exclusivement dédiée à
                    l'agriculture
                </p>

                <p>
                    Groupama est aujourd’hui le partenaire majeur de la première plateforme de financement participatif
                    exclusivement dédiée à l’agriculture et à l’alimentation, <span class="marker green">MiiMOSA</span>.
                </p>

            </section>
            <section>
                <p>
                    Hugo, découvre aujourd’hui un nouveau métier, celui de producteur de noix et noisettes. «&nbsp;Je
                    cherchais
                    une meilleure valorisation de mes terres à faibles potentiels pour pérenniser l’exploitation&nbsp;»
                    explique-t-il.<br>
                    <br>
                    Début 2019, avec un collectif de huit autres céréaliers, Hugo a ainsi planté 50 ha qu’ils gèrent
                    grâce à
                    Gari, l’assistant agricole lancé par Groupama au dernier salon de l’agriculture.<br>
                    <br>
                    Une application mobile qui lui permet de veiller sur son exploitation depuis son Smartphone à l’aide
                    d’un tableau de bord unique avec lequel il peut gérer l’ensemble des tâches des membres de son
                    exploitation.<br>
                    <br>
                    Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum dimicationum curulium
                    eventu pendentem. haec similiaque memorabile nihil vel serium agi Romae permittunt. ergo redeundum
                    ad
                    textum.<br>
                    <br>
                    Ultima Syriarum est Palaestina per intervalla magna protenta, cultis abundans terris et nitidis et
                    civitates habens quasdam egregias, nullam nulli cedentem sed sibi vicissim velut ad perpendiculum
                    aemulas: Caesaream, quam ad honorem Octaviani principis exaedificavit Herodes, et Eleutheropolim et
                    Neapolim itidemque Ascalonem Gazam aevo superiore exstructas. <br>
                    Et quia Mesopotamiae tractus omnes crebro inquietari sueti praetenturis et stationibus servabantur
                    agrariis, laevorsum flexo itinere Osdroenae subsederat extimas partes, novum parumque aliquando
                    temptatum commentum adgressus. quod si impetrasset, fulminis modo cuncta vastarat. erat autem quod
                    cogitabat huius modi.Et est admodum mirum videre plebem innumeram mentibus ardore quodam infuso cum
                    dimicationum curulium eventu pendentem. haec similiaque memorabile nihil vel serium agi Romae
                    permittunt. ergo redeundum ad textum. <br>
                    <br>
                    Ultima Syriarum est Palaestina per intervalla magna protenta, cultis abundans terris et nitidis et
                    civitates habens quasdam egregias, nullam nulli cedentem sed sibi vicissim velut ad perpendiculum
                    aemulas: Caesaream, quam ad honorem Octaviani principis exaedificavit Herodes, et Eleutheropolim et
                    Neapolim itidemque Ascalonem Gazam aevo superiore exstructas. <br>
                    <br>
                    Et quia Mesopotamiae tractus omnes crebro inquietari sueti praetenturis et stationibus servabantur
                    agrariis, laevorsum flexo itinere Osdroenae subsederat extimas partes, novum parumque aliquando
                    temptatum commentum adgressus. quod si impetrasset, fulminis modo cuncta vastarat. erat autem quod
                    cogitabat huius modi.
                </p>
            </section>
        </article>

        <article>
            <section></section>
            <section>
                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>Retrouvez tous les faits qui ont marqué notre année en</p>
                        <p><span>Téléchargeant</span> le rapport annuel</p>
                    </div>
                </a>
            </section>
        </article>


    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>

<style scoped lang="scss">

    main {
        position: relative;
    }

    .close {

        &-box {
            position: absolute;
            right: 10px;
            top: 10px;
        }

        margin-left: auto;
        position: sticky;
        top: 10px;
        right: 10px;
    }

    article {
        display: flex;
        justify-content: space-between;

        section {

            display: flex;
            flex-direction: column;

            &:first-child {
                max-width: 340px;
            }

            &:last-child {
                max-width: 480px;
            }

            &.text-right {
                text-align: right;

                .label {
                    align-self: flex-end;
                }

                .icono {
                    align-self: flex-end;
                }

            }

            figure {
                margin: 0 0 70px;

                img.picture {
                    max-width: 100%;
                }

                figcaption {
                    text-transform: uppercase;
                    text-align: right;
                    font-weight: 600;
                }
            }


            h1 {
                text-transform: uppercase;
                display: flex;
                flex-direction: column;
                font-size: 30px;
                margin-bottom: 15px;

                span {
                    align-self: flex-start;
                    color: white;
                    background: #00604f;
                    padding: 1px 5px 0;

                    em {
                        font-style: normal;
                        color: #ecbf3e;
                    }
                }
            }

            h2 {
                font-weight: 900;
                color: #00604f;
                font-size: 22px;
                line-height: 25px;
            }

            h3 {
                color: #ecbf3e;
                font-size: 16px;
                text-transform: uppercase;
                font-weight: 700;
                line-height: 18px;
            }

            p {
                font-size: 16px;
                line-height: 18px;
                font-weight: 500;
                color: #0b0b0b;

                &.yellow {
                    color: #ecbf3e;
                }

                &.green {
                    color: #00604f;
                }

                &.uppercase {
                    text-transform: uppercase;
                }

                &.semiBold {
                    font-weight: 700;
                }

            }

            .label {
                font-weight: 800;
                text-transform: uppercase;

                &.green {
                    background: #004135;
                    padding: 5px;
                    color: white;
                }
            }

            .marker {
                &.green {
                    display: inline-block;
                    color: white;
                    background: #00604f;
                    padding: 3px;
                }
            }

            .number {
                font-size: 70px;
                padding: 15px 15px 5px;
                line-height: 1;
                display: flex;
                justify-content: flex-end;
                align-self: flex-end;
                margin: 0 0 10px;
                font-weight: 900;

                sup {

                }

                &.yellow {
                    background: #ecbf3e;
                    color: white;
                }
            }

            .link {
                display: flex;
                text-decoration: none;
                margin-top: 20px;
                padding: 5px;
                transition: .25s ease;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0);

                &:hover {
                    background: #a1bf38;
                    transform: scale(1.02);
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);

                    .link {
                        &-icon {
                            fill: #00352c;
                        }

                        &-content {
                            p {
                                color: #00352c;
                            }
                        }
                    }

                }

                &-icon {
                    width: 30px;
                    height: 40px;
                    fill: #a1bf38;
                    margin-right: 20px;
                    transition: .25s ease;
                }

                &-content {
                    p {
                        font-size: 16px;
                        margin: 0;
                        transition: .25s ease;
                        display: inline-block;

                        span {
                            text-decoration: underline;
                        }

                        &:first-child {
                            font-weight: 500;
                            color: #00604f;
                            margin-bottom: 6px;
                        }

                        &:last-child {
                            font-weight: 800;
                            text-transform: uppercase;
                            color: #a1bf38;
                        }
                    }
                }

            }

            .icono {
                margin-top: 70px;
            }

            .w96 {
                max-width: 120px;
            }
        }

        .quote {
            width: 99px;
            height: 71px;
            display: block;

            &.yellow {
                fill: #ecbf3e;
            }
        }
    }

    @media screen and (max-width: 1280px) {


        article {
            section {
                padding-left: 15px;
                padding-right: 15px;
            }
        }

    }

    @media screen and (max-width: 780px) {

        article {
            flex-direction: column;
            padding: 0 25px;

            &.xs-reverse {
                flex-direction: column-reverse;
            }

        }


        figure img {
            margin-bottom: 20px;
        }

        figcaption p {
            margin-bottom: 0;
            margin-top: 0px;
        }

    }

</style>
